(function () {
	"use strict";

	var module = angular.module("uwAgenda.agenda");

	// controller for agenda-day
	module.controller("AgendaDayTimeController", [
		"$rootScope",
		"$state",
		"$window",
		"Alert",
		"AppointmentService",
		"AgendaBroadcast",
		"SharedAgendaService",
		"AgendaOverviewService",
		"DateService",
		"AppointmentDetailService",
		"Appointment",
		"AppointmentRecurrenceUpdateService",
		"ProtocolBroadcastService",
		"ProtocolFilter",
		"AgendaFilterBroadcast",
		"HelperService",
		"AgendaTransitionService",
		"TaskService",
		"UserService",
		'$translate',
		'IntegratorTypeEnum',
		AgendaDayTimeControllerFn,
	]);

	function AgendaDayTimeControllerFn(
		$rootScope,
		$state,
		$window,
		Alert,
		AppointmentService,
		AgendaBroadcast,
		SharedAgendaService,
		AgendaOverviewService,
		DateService,
		AppointmentDetailService,
		Appointment,
		AppointmentRecurrenceUpdateService,
		ProtocolBroadcastService,
		ProtocolFilter,
		AgendaFilterBroadcast,
		HelperService,
		AgendaTransitionService,
		TaskService,
		UserService,
		$translate,
		IntegratorTypeEnum
	) {
		var vm = this;

		// agenda overview service data
		vm.overview = {};

		vm.isPartOfEyeFileIntegration = SharedAgendaService.currentUserIsPartOfEyeFileIntegration();

		activate();

		vm.deleteAppointment = function (event) {
			if (event) {
				event.stopPropagation();
			}
			// is appointment
			if (vm.time.isAppointment) {
				if (vm.time.isRecurringAppointment) {
					AppointmentRecurrenceUpdateService.getUpdateMethod().then(function (
						recurrenceUpdate
					) {
						deleteAppointment(recurrenceUpdate);
					});
				} else {
					deleteAppointment(null);
				}
			} //if
		};

		vm.openPatientInMediris = function (event) {
			if (event) {
				event.stopPropagation();
			}
			if (vm.time.agenda && vm.time.agenda.medirisIntegration) {
				var birthday = vm.time.patientBirthday
					? moment(vm.time.patientBirthday, "DD/MM/YYYY")
					: null;
				var medirisUrl = HelperService.getMedirisUrl(
					vm.time.patientFirstName,
					vm.time.patientLastName,
					birthday
				);

				$window.open(medirisUrl, "_blank");
			}
		};


		vm.OpenPrintModal = function () {
			AgendaOverviewService.showPrintModal($rootScope, vm.time.appointmentId, vm.time.agendaId)
		}

		vm.openPatientInEyeFile = function (event) {
			if (event) {
				event.stopPropagation();
			}
			if (vm.time.agenda) {
				let birthday = vm.time.patientBirthday
					? moment(vm.time.patientBirthday, "DD/MM/YYYY")
					: null;
				
				let url = null;
				if (vm.isPartOfEyeFileIntegration) {
					url = HelperService.getEyeFileUrlNew(
						vm.time.patientFirstName,
						vm.time.patientLastName,
						birthday,
						vm.time.contactInfoMobile,
						vm.time.contactInfoEmail,
						vm.time.patientUniqueId,
						vm.time.patientSyncFileId
					);
				}
				
				if (url != null) {
					$window.open(url, "_blank");
				}
			}
		};

		function deleteAppointment(recurrenceUpdateMethod) {
			AppointmentService.showDeleteConfirmationModal(
				vm.time.appointmentId,
				recurrenceUpdateMethod
			).then(function (result) {
				if (result === undefined) {
					return;
				}

				vm.time.deleted = true;

				// show protocol
				ProtocolBroadcastService.broadcast(
					ProtocolFilter.ShowOnAppointmentDelete
				);

				// inform listeners
				$rootScope.$broadcast(
					AgendaFilterBroadcast.ListRefresh,
					vm.time.agendaId
				);
			});
		}

		// confirm
		vm.confirm = function () {
			// is appointment
			if (vm.time.isAppointment) {
				AppointmentService.confirm(vm.time.appointmentId).then(function (
					result
				) {
					// update view
					vm.time.confirmed = true;
					// inform
					$rootScope.$broadcast(
						AgendaBroadcast.AppointmentConfirmed,
						vm.time.agendaId
					);
				});
			} //if
		};

		vm.taskFromAppointment = function () {
			if (vm.time.isAppointment) {
				// show new task dialog, with all appointment details already filled in
				TaskService.newTaskForAppointment(vm.time.appointmentId).then(
					function () {
						if ($state.current.name === "Home.Search") {
							var agenda = SharedAgendaService.getAgenda(vm.time.agendaId);
							AgendaTransitionService.change(
								agenda.owner.id,
								vm.time.appointmentDate
							);
						}
					}
				);
			}
		};

		// paste time
		vm.paste = function () {
			// abort copy process
			$rootScope.$broadcast(AgendaBroadcast.AbortCutCopy);

			// paste appointment to this agenda-time-object
			if (vm.time.isAppointment) {
				return;
			}
			// if label is readonly
			if (vm.time.isReadOnly) {
				return;
			}
			// is dayscheme time id available ?
			if (vm.time.daySchemeTimeId === null || vm.time.daySchemeTimeId <= 0) {
				return;
			}

			// get appointment to paste from overview service
			var toPaste = vm.overview.timeToPaste;
			if (typeof toPaste === "undefined" || toPaste === null) {
				return;
			}

			// New Date To Paste To
			var date = vm.time.itemDate;

			// copy or cut ?
			if (vm.overview.copy) {
				// just copy
				// replace current one with new one
				if (toPaste.isRecurringAppointment) {
					AppointmentRecurrenceUpdateService.getUpdateMethod().then(function (
						recurrenceUpdate
					) {
						copyAppointment(toPaste, date, recurrenceUpdate);
					});
				} else {
					copyAppointment(toPaste, date, null);
				}
			} // if
			else {
				// cut and paste
				// replace current one with new one
				if (toPaste.isRecurringAppointment) {
					AppointmentRecurrenceUpdateService.getUpdateMethod().then(function (
						recurrenceUpdate
					) {
						cutAndPasteAppointment(toPaste, date, recurrenceUpdate);
					});
				} else {
					cutAndPasteAppointment(toPaste, date, null);
				}
			} // else
		};

		vm.blockTime = function (event) {
			event.stopPropagation();
			AppointmentService.blockTime(vm.time);
		};

		vm.deleteUserTime = function (event) {
			event.stopPropagation();
			AppointmentService.deleteUserTime(vm.time);
		};

		vm.editTime = function (event) {
			event.stopPropagation();
			AppointmentService.editTime(vm.time);
		};

		// call service method to past appointment
		function cutAndPasteAppointment(toPaste, date, recurrenceUpdateMethod) {
			AppointmentService.cutAndPaste(
				toPaste.appointmentId,
				vm.time.daySchemeTimeId,
				toPaste.agendaId,
				vm.time.agendaId,
				date,
				recurrenceUpdateMethod
			).then(function (result) {
				// show protocol
				ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnAppointmentCut);

				// clear item to paste
				AgendaOverviewService.clear();

				// inform listeners
				$rootScope.$broadcast(
					AgendaFilterBroadcast.ListRefresh,
					vm.time.agendaId
				);
			});
		}

		vm.blockUser = function (event) {
			return UserService.showBlockUserModal(
				vm.time.patientId,
				vm.time.agendaId,
				vm.time.patient
			).then(function () {
				Alert.success(
					$translate.instant("user_blocked_success", {name: vm.time.patient})
				);
			});
		};

		// copy an appointment
		function copyAppointment(toPaste, date, recurrenceUpdateMethod) {
			AppointmentService.copy(
				toPaste.appointmentId,
				vm.time.daySchemeTimeId,
				toPaste.agendaId,
				vm.time.agendaId,
				date,
				recurrenceUpdateMethod
			).then(function (result) {
				// show protocol
				ProtocolBroadcastService.broadcast(
					ProtocolFilter.ShowOnAppointmentCopy
				);

				// clear item to paste
				AgendaOverviewService.clear();

				// inform listeners
				$rootScope.$broadcast(
					AgendaFilterBroadcast.ListRefresh,
					vm.time.agendaId
				);
			});
		}

		// abort cut/copy/paste
		vm.abort = function (event) {
			// abort copy process
			$rootScope.$broadcast(AgendaBroadcast.AbortCutCopy);
			AgendaOverviewService.clear();
			event.preventDefault();
			event.stopPropagation();
		};

		// start copy
		vm.copy = function (event) {
			if (event) {
				event.stopPropagation();
			}
			AgendaOverviewService.copying(vm.time);
		};

		// start cut
		vm.cut = function (event) {
			if (event) {
				event.stopPropagation();
			}
			AgendaOverviewService.cutting(vm.time);
		};

		vm.showAppointmentDetailModal = function () {
			AppointmentDetailService.show(vm.time.appointmentId, vm.time.agendaId);
		};

		vm.showAppointmentDay = function () {
			var agenda = SharedAgendaService.getAgenda(vm.time.agendaId);
			AgendaTransitionService.change(agenda.owner.id, vm.time.appointmentDate);
		};

		// new appointment
		vm.new = function (event) {
			event.stopPropagation();
			// get selected agenda from shared-agenda-service
			var agenda = SharedAgendaService.getAgenda(vm.time.agendaId);

			// if there is still an appointment -> check if multiple appointments are allowed
			AppointmentDetailService.data.agendaItem = null;
			if (vm.time.isAppointment) {
				if (!agenda.allowMultipleAppointments) {
					return;
				}
			}

			// if label does not allow making appointments
			if (vm.time.isReadOnly) {
				return;
			}

			// is copy or cut in progress ?
			if (vm.overview.cutCopyInProgress) {
				Alert.warning("A Cut/Copy Process is in Progress");
				return;
			}

			// do we have to update the date in the date-service -> if we come from WEEK-View it could be possible !!!
			if (typeof vm.date !== "undefined" && DateService.data.date !== vm.date) {
				DateService.date(new Date(vm.date));
			} // if

			// is time after current day-time ?
			time().then(function (timeInThePast) {
				if (timeInThePast) {
					// in the past !
					return;
				} else {
					// force no time check
					AppointmentDetailService.data.doTimeChecks = false;
					// set needed values -> agenda-lables and appointment-types of agenda
					AppointmentDetailService.setEmail(
						agenda.owner.caption,
						agenda.owner.mainEmail
					);
					AppointmentDetailService.setMobile(
						agenda.owner.caption,
						agenda.owner.mainMobile
					);

					// create new appointment-object
					var agendaLabelText = vm.time.agendaLabelCaption;
					if ($rootScope.isRingfoon) {
						agendaLabelText =
							vm.time.agendaLabelCaptionIntern || vm.time.agendaLabelCaption;
					}

					if (!vm.time.appointmentId) {

						var appointment = new Appointment();
						appointment.init(
							vm.time.agendaLabelId,
							vm.time.daySchemeTimeId,
							vm.time.hour,
							vm.time.minute,
							agendaLabelText,
							vm.time.colorCaption
						);

						// double booking on same timeslot -> store agendaLabel in service
						if (
							vm.time.isAppointment &&
							AppointmentDetailService.data.labels.push
						) {
							AppointmentDetailService.data.agendaItem = appointment.agendaLabel;
						}

						// set data to service
						AppointmentDetailService.data.agenda = agenda;
						AppointmentDetailService.data.appointment = appointment;

						//todo noch die relevanten daten ermitteln
						$state.go("Home.Agenda_Appointment");
					} else {

						AppointmentService.get(vm.time.appointmentId)
							.then(function (appointmentForEdit) {


								var appointment = new Appointment();
								appointment.appointmentType = {id: null};

								var label = {
									agendaLabelId: appointmentForEdit.agendaLabel.id,
									daySchemeTimeId: appointmentForEdit.fK_DaySchemeTime,
									isAppointment: true,
									hideTime: appointmentForEdit.hideTime,
									hour: appointmentForEdit.hour,
									minute: appointmentForEdit.minute,
									agendaLabelText: appointmentForEdit.agendaLabel.text,
									timeCaption: `${appointmentForEdit.hour.toString().padStart(2, '0')}:${appointmentForEdit.minute.toString().padStart(2, '0')}`
								};

								// copy appointment agendalabel properties to custom UI label
								Object.assign(label, appointmentForEdit.agendaLabel);

								appointment.agendaLabel = label;

								// double booking on same timeslot -> store agendaLabel in service
								if (
									vm.time.isAppointment &&
									AppointmentDetailService.data.labels.push
								) {
									AppointmentDetailService.data.agendaItem = appointment.agendaLabel;
								}

								// set data to service
								AppointmentDetailService.data.agenda = agenda;
								AppointmentDetailService.data.appointment = appointment;

								$state.go("Home.Agenda_Appointment");
							});
					}
				} // else
			});
		};

		// build datetime object for further checks
		function time() {
			// set time to service
			AppointmentDetailService.data.time.hour = vm.time.hour;
			AppointmentDetailService.data.time.minute = vm.time.minute;
			// force time check
			AppointmentDetailService.data.doTimeChecks = true;

			// set agenda
			AppointmentDetailService.data.agenda = vm.time.agenda;

			return AppointmentDetailService.inThePast();
		} // time

		// activation work
		function activate() {
			// overview
			vm.overview = AgendaOverviewService.data;
			if (vm.time.content) {
				vm.htmlStrippedDescription =
					HelperService.removeLineBreaksFromString(HelperService.htmlToPlainText(vm.time.content));
			}
		} // activate
	}
})();
